// src/config/api.js
import { sameOriginWs } from '../utils/wsUrl';
const API_BASE_URL = process.env.REACT_APP_API_URL || '/';
const WS_BASE_URL = process.env.REACT_APP_WS_URL || sameOriginWs('/ws/strategy-alerts/');

const API_URLS = {
  // ==================== AUTHENTICATION ====================
  CSRF_TOKEN: `${API_BASE_URL}/authentication/csrf/`,
  LOGIN: `${API_BASE_URL}/authentication/login/`,
  LOGOUT: `${API_BASE_URL}/authentication/logout/`,
  CURRENT_USER: `${API_BASE_URL}/authentication/current-user/`,
  ADMIN_SIGNUP: `${API_BASE_URL}/authentication/admin/signup/`,
  OFFICER_SIGNUP: `${API_BASE_URL}/authentication/officer/signup/`,
  
  // ==================== USER MANAGEMENT ====================
  USER_LIST: `${API_BASE_URL}/authentication/users/`,
  USER_ACTIVITY: `${API_BASE_URL}/authentication/users/activity/`,
  USER_DEACTIVATE: (id) => `${API_BASE_URL}/authentication/users/${id}/deactivate/`,
  
  // ==================== SCRIPTS (Trading Scripts) ====================
  SCRIPTS_LIST: `${API_BASE_URL}/api/scripts/`,
  SCRIPT_CREATE: `${API_BASE_URL}/api/scripts/`,
  SCRIPT_DETAIL: (id) => `${API_BASE_URL}/api/scripts/${id}/`,
  
  // ==================== SEQUENCES ====================
  SEQUENCES_LIST: `${API_BASE_URL}/api/sequences/`,
  SEQUENCE_CREATE: `${API_BASE_URL}/api/sequences/`,
  SEQUENCE_DETAIL: (id) => `${API_BASE_URL}/api/sequences/${id}/`,
  SEQUENCE_STATES: `${API_BASE_URL}/api/sequences/states/`,
  SEQUENCE_RESET: (id) => `${API_BASE_URL}/api/sequences/${id}/reset/`,
  
  // ==================== COMPLETED SEQUENCES ====================
  COMPLETED_SEQUENCES: `${API_BASE_URL}/api/completed-sequences/`,
  COMPLETED_SEQUENCE_DETAIL: (stateId) => `${API_BASE_URL}/api/completed-sequences/${stateId}/`,
  SEQUENCE_STATS: `${API_BASE_URL}/api/sequence-stats/`,
  SEQUENCE_TIMELINE: `${API_BASE_URL}/api/sequence-timeline/`,
  
  // ==================== SIGNALS ====================
  SIGNALS_LIST: `${API_BASE_URL}/api/signals/`,
  WEBHOOK: (endpoint) => `${API_BASE_URL}/webhook/${endpoint}/`,
  
  // ==================== STRATEGIES (Signal Aggregation) ====================
  STRATEGIES_LIST: `${API_BASE_URL}/api/strategies/`,
  STRATEGY_CREATE: `${API_BASE_URL}/api/strategies/`,
  AGGREGATIONS_LIST: `${API_BASE_URL}/api/aggregations/`,
  
  // ==================== ALERTS (Old System) ====================
  ALERTS_LIST: `${API_BASE_URL}/api/alerts/`,
  ALERT_CREATE: `${API_BASE_URL}/api/alerts/`,
  ALERT_DETAIL: (id) => `${API_BASE_URL}/api/alerts/${id}/`,
  ALERT_STATES: `${API_BASE_URL}/api/alert-states/`,
  ALERT_STATS_OLD: `${API_BASE_URL}/api/alert-stats/`,

  // ==================== NEW STRATEGY SYSTEM ====================
  // Dashboard
  DASHBOARD_STATS: `${API_BASE_URL}/alerts/api/dashboard/stats/`,
  DASHBOARD_PERFORMANCE: `${API_BASE_URL}/alerts/api/dashboard/performance/`,
  
  // Strategy management
  STRATEGY_SETUP: `${API_BASE_URL}/alerts/api/strategy/setup/`,
  STRATEGY_LIST: `${API_BASE_URL}/alerts/api/strategy/list/`,
  STRATEGY_STATE: (strategyId) => `${API_BASE_URL}/alerts/api/strategy/state/${strategyId}/`,
  STRATEGY_RESET: `${API_BASE_URL}/alerts/api/strategy/reset/`,
  STRATEGY_DELETE: (strategyId) => `${API_BASE_URL}/alerts/api/strategy/delete/${strategyId}/`,
  STRATEGY_DETAIL: (strategyId) => `${API_BASE_URL}/alerts/api/strategy/detail/${strategyId}/`,
  
  // Signal processing
  SIGNAL_ALERT: `${API_BASE_URL}/alerts/api/signal/alert/`,
  
  // History and logs
  SIGNALS_HISTORY: (strategyId) => `${API_BASE_URL}/alerts/api/signals/history/${strategyId}/`,
  SIGNAL_EVENTS: (strategyId) => `${API_BASE_URL}/alerts/api/signals/events/${strategyId}/`,
  
  // Alert history endpoints
  ALERTS_HISTORY: `${API_BASE_URL}/alerts/api/alerts/history/`,
  ALERT_STATS: `${API_BASE_URL}/alerts/api/alerts/stats/`,

  // Monitoring
  CONDITION_HISTORY: `${API_BASE_URL}/alerts/api/monitoring/conditions/`,
  STRATEGY_ACTIVITY: `${API_BASE_URL}/alerts/api/monitoring/strategies/`,

  // ==================== BULK STRATEGY SYSTEM ====================
  // Setup and management
  BULK_STRATEGY_SETUP: `${API_BASE_URL}/alerts/api/bulk-strategy/setup/`,
  BULK_STRATEGY_LIST: `${API_BASE_URL}/alerts/api/bulk-strategy/list/`,
  BULK_STRATEGY_DETAIL: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/detail/${bulkStrategyId}/`,
  BULK_STRATEGY_STATUS: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/status/${bulkStrategyId}/`,
  BULK_STRATEGY_DELETE: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/delete/${bulkStrategyId}/`,
  
  // Exit and reset
  BULK_STRATEGY_EXIT: `${API_BASE_URL}/alerts/api/bulk-strategy/exit/`,
  BULK_STRATEGY_MANUAL_CHECK: `${API_BASE_URL}/alerts/api/bulk-strategy/manual-check/`,
  
  // History and analysis
  BULK_STRATEGY_SIGNAL_HISTORY: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/signals/history/${bulkStrategyId}/`,
  BULK_STRATEGY_TIMELINE: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/signal-timeline/${bulkStrategyId}/`,
  BULK_STRATEGY_EXPORT_EXCEL: (bulkStrategyId) => `${API_BASE_URL}/alerts/api/bulk-strategy/export-timeline/${bulkStrategyId}/`,
  
  // ==================== UNIVERSAL SIGNAL BROADCASTING ====================
  SIGNAL_BROADCAST: `${API_BASE_URL}/alerts/api/signal/broadcast/`,
  SIGNAL_EXIT_BROADCAST: `${API_BASE_URL}/alerts/api/signal/exit-broadcast/`,

  // ==================== AGENT CHAT ====================
  AGENT_CHAT: `${API_BASE_URL}/alerts/api/agent/chat/`,
};

// WebSocket Configuration
export const WS_CONFIG = {
  URL: WS_BASE_URL,
  RECONNECT_INTERVAL: 1000,
  MAX_RECONNECT_ATTEMPTS: 10,
  PING_INTERVAL: 30000, // 30 seconds
};

// Keep this for backward compatibility
export const WS_URL = WS_BASE_URL;

// Default export
export default API_URLS;
